import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "One York Freight collects the information you provide through our inquiry and interest forms solely to respond to your request and coordinate potential transportation services.",
      "Information submitted may include your name, company, contact details and shipment details. We use this information to review your inquiry and contact you regarding available transportation options.",
      "Do not submit highly sensitive personal information, passport details, payment-card data or government identification through our public forms.",
      "A website inquiry does not automatically confirm a booking. We do not sell your information. We retain inquiry records for operational and communication purposes.",
    ],
  },
  terms: {
    title: "Terms and Conditions",
    body: [
      "A website inquiry does not automatically confirm a booking. Service is subject to cargo review, route, availability, regulations and acceptance.",
      "Quotes may change when shipment information is inaccurate or incomplete. Customers are responsible for providing accurate shipment and commodity information.",
      "Pickup and delivery times may be affected by weather, traffic, border processing, inspections, documentation and events outside the company's control.",
      "Customs clearance is controlled by government authorities and handled with the shipment's authorized customs broker. One York Freight is not a customs broker.",
      "We do not claim guaranteed delivery unless a specific written service agreement provides that guarantee.",
      "The training course is educational and does not constitute legal, accounting, insurance, customs or regulatory advice.",
    ],
  },
  accessibility: {
    title: "Accessibility",
    body: [
      "One York Freight is committed to providing an accessible website experience for all visitors.",
      "This website applies strong colour contrast, keyboard-accessible navigation, visible focus states, descriptive image alternative text, labelled form fields and support for reduced-motion preferences.",
      "If you experience any difficulty accessing content on this website, please contact us at oneyorkfreight@gmail.com or 647-627-7787 and we will work to provide the information you need.",
    ],
  },
};

export const LegalModal = ({ type, onClose }) => {
  const data = type ? CONTENT[type] : null;
  return (
    <Dialog open={!!type} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto bg-white" data-testid="legal-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-oyf-black">{data?.title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-oyf-medgrey text-[15px] leading-relaxed">
          {data?.body.map((p, i) => (
            <p key={i} className="flex gap-3"><span className="mt-2 h-1.5 w-1.5 bg-oyf-yellow rounded-full shrink-0" />{p}</p>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
